
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"7","height":"9","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M4.677.355H2.356L1.892.8H.267v.887h6.5V.799H5.142L4.677.355zm.697 2.661v4.435H1.659V3.016h3.715zM.73 2.129h5.571v5.322c0 .488-.418.887-.928.887H1.659c-.51 0-.928-.4-.928-.887V2.129z","fill":"#000","fill-opacity":".54"}})])
          )
        }
      }
    